import React from 'react';
import {
    Button,
    Label
} from 'reactstrap';
import { colorTheme } from '../../utils/constants';
import { IonButton, IonIcon } from '@ionic/react';
import { close, closeCircleOutline, ellipse } from 'ionicons/icons';


export default class UploadFile extends React.Component{
    constructor(props){
        super(props);
        this.inputFileRef = React.createRef();
    }

    handleSelectFile() {
        /*Collecting node-element and performing click*/
        this.inputFileRef.current.click();
    }

    render(){
        return (<React.Fragment>
            {!this.props.noShowLabel && (
            <React.Fragment>
                <Label for="file">
                    {this.props.label || "File upload:"}
                </Label>
                <br/>
                </React.Fragment>
            )}

            {this.props.fileName && (<p>
                <a
                    className="h5"
                    style={{textDecorationLine: 'underline' }}
                    onClick={() => this.props.handleDownloadFile()}>
                    {this.props.fileName}
                </a>
                {!this.props.readOnly && (<a
                    className="ml-3"
                    onClick={() => this.props.handleClose() }
                >
                    <span className="fa-stack fa-lg">
                        <IonIcon icon={close} className="text-secondary" />
                    </span>
                </a>)}
            </p>)}

            <input
                type="file"
                style={{ display: 'None' }}
                ref={this.inputFileRef}
                onChange={ (event) => this.props.handleChangeFile(event)}
            />
            <p>
                <IonButton
                    className="mr-2"
                    style={{borderColor: colorTheme["primary"]["700"] }}
                    onClick={() => this.handleSelectFile()}
                    disabled={this.props.readOnly}
                >
                    {this.props.fileName? "Replace": "Choose file"}
                </IonButton>
                {this.props.fileName? "" : "No file chosen"}
            </p>
        </React.Fragment>)
    }
}